import { render } from "./EventsComponent.vue?vue&type=template&id=be2442c8"
import script from "./EventsComponent.vue?vue&type=script&lang=js"
export * from "./EventsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__